export default {
    SUBMIT_IMPORTAR_PEDIDOS: 'SUBMIT_IMPORTAR_PEDIDOS',
    SUBMIT_IMPORTAR_PEDIDOS_SUCCESS: 'SUBMIT_IMPORTAR_PEDIDOS_SUCCESS',
    ABRIR_MODAL_IMPORTAR_PEDIDOS: 'ABRIR_MODAL_IMPORTAR_PEDIDOS',
    CERRAR_MODAL_IMPORTAR_PEDIDOS: 'CERRAR_MODAL_IMPORTAR_PEDIDOS',
    SUBIR_ARCHIVOS_IMPORTAR_PEDIDOS: 'SUBIR_ARCHIVOS_IMPORTAR_PEDIDOS',
    DESCARGAR_PLANTILLA_EXCEL_PEDIDOS: 'DESCARGAR_PLANTILLA_EXCEL_PEDIDOS',
    DESCARGAR_PEDIDOS: 'DESCARGAR_PEDIDOS'
  }